import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[lettersAndSpacesOnly]'
})
export class LettersAndSpacesDirective {
  
  @HostListener('keypress', ['$event']) 
  onKeyPress(event: KeyboardEvent) {
    // Permite letras (incluidas ñ, acentos, apóstrofes y diéresis)
    const regex = /^[a-zA-ZáéíóúüÁÉÍÓÚÜñÑ'\s]$/;
    
    if (regex.test(event.key)) {
      return true;
    }
    
    event.preventDefault();
    return false;
  }
}
